(function () {
    var root = document.getElementById('md-acc-prefs-app');
    if (!root || typeof mdMealPrep === 'undefined') {
        return;
    }
    var M = window.MDMeals;
    if (!M || !M.api) {
        return;
    }

    var form = document.getElementById('md-acc-prefs-form');
    var loading = document.getElementById('md-acc-prefs-loading');
    var errEl = document.getElementById('md-acc-prefs-error');
    var statusEl = document.getElementById('md-acc-prefs-status');
    var saveBtn = document.getElementById('md-acc-prefs-save');
    var custTa = document.getElementById('md-acc-prefs-cust');
    var custCount = document.getElementById('md-acc-prefs-cust-count');
    var fromWelcome = (root.getAttribute('data-from') || '') === 'welcome';
    var initialPrefsSavedAt = '';

    function esc(s) {
        return M.esc(String(s == null ? '' : s));
    }
    function showErr(m) {
        if (!errEl) return;
        if (m) {
            errEl.textContent = m;
            errEl.hidden = false;
        } else {
            errEl.textContent = '';
            errEl.hidden = true;
        }
    }
    function showStatus(m) {
        if (statusEl) statusEl.textContent = m || '';
    }
    function welcomeRedirect() {
        var accountUrl = (mdMealPrep && mdMealPrep.accountUrl) || '/account/';
        try {
            var u = new URL(accountUrl, window.location.origin);
            u.pathname = u.pathname.replace(/\/?$/, '/') + 'welcome/';
            u.searchParams.set('saved', 'prefs');
            window.location.href = u.toString();
        } catch (e) {
            window.location.href = accountUrl + 'welcome/?saved=prefs';
        }
    }

    function renderCheckboxes(container, options, selected, fieldName) {
        if (!container) return;
        var sel = {};
        (selected || []).forEach(function (id) {
            sel[String(id)] = true;
        });
        var h = '';
        (options || []).forEach(function (t) {
            var id = t.id;
            var checked = sel[String(id)] ? ' checked' : '';
            var bid = 'md-pref-' + fieldName + '-' + id;
            h +=
                '<label class="md-pref-check"><input type="checkbox" name="' + fieldName + '[]" id="' +
                esc(bid) + '" value="' + id + '"' + checked + '> <span>' + esc(t.name) + '</span></label>';
        });
        container.innerHTML = h || '<p class="md-meals-note">No options yet.</p>';
    }

    function renderSpiceCheckboxes(container, options, selected, fieldName) {
        if (!container) return;
        var sel = {};
        (selected || []).forEach(function (slug) {
            sel[String(slug)] = true;
        });
        var h = '';
        (options || []).forEach(function (t) {
            var slug = t.value || t.slug || '';
            var label = t.label || t.name || slug;
            if (!slug) return;
            var checked = sel[String(slug)] ? ' checked' : '';
            var bid = 'md-pref-' + fieldName + '-' + slug;
            h +=
                '<label class="md-pref-check"><input type="checkbox" name="' + fieldName + '[]" id="' +
                esc(bid) + '" value="' + esc(slug) + '"' + checked + '> <span>' + esc(label) + '</span></label>';
        });
        container.innerHTML = h || '<p class="md-meals-note">No options yet.</p>';
    }

    function updateCharCount() {
        if (custTa && custCount) custCount.textContent = String((custTa.value || '').length);
    }

    function applyProfile(d) {
        if (!d) return;
        if (custTa) {
            custTa.value = d.customer_preferences || '';
            updateCharCount();
        }
        var po = d.pref_options || {};
        renderCheckboxes(form.querySelector('[data-field="pref_dietary"]'), po.md_dietary, d.pref_dietary, 'pref_dietary');
        renderCheckboxes(form.querySelector('[data-field="pref_allergen"]'), po.md_allergen, d.pref_allergen, 'pref_allergen');
        renderSpiceCheckboxes(form.querySelector('[data-field="pref_spice"]'), po.md_spice_level, d.pref_spice, 'pref_spice');
    }

    function collectChecks(name) {
        var ids = [];
        form.querySelectorAll('input[name="' + name + '[]"]:checked').forEach(function (b) {
            var n = parseInt(b.value, 10);
            if (n > 0) ids.push(n);
        });
        return ids;
    }

    function collectSpiceChecks(name) {
        var slugs = [];
        form.querySelectorAll('input[name="' + name + '[]"]:checked').forEach(function (b) {
            var v = String(b.value || '').trim();
            if (v) slugs.push(v);
        });
        return slugs;
    }

    function load() {
        showErr('');
        M.api('profile', { method: 'GET' })
            .then(function (d) {
                if (loading) {
                    loading.hidden = true;
                    loading.setAttribute('aria-busy', 'false');
                }
                form.hidden = false;
                applyProfile(d);
                initialPrefsSavedAt = String(d.prefs_saved_at || '');
            })
            .catch(function (e) {
                if (loading) loading.innerHTML = '<p class="md-meals-error">' + esc(e.message || e) + '</p>';
            });
    }

    if (custTa) custTa.addEventListener('input', updateCharCount);

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        showErr('');
        showStatus('');
        if (saveBtn) saveBtn.disabled = true;
        var fd = new FormData(form);
        var body = {
            preferences: true,
            customer_preferences: fd.get('customer_preferences'),
            pref_dietary: collectChecks('pref_dietary'),
            pref_allergen: collectChecks('pref_allergen'),
            pref_spice: collectSpiceChecks('pref_spice'),
        };
        M.api('profile', { method: 'POST', body: body })
            .then(function (d) {
                applyProfile(d);
                showStatus('Saved.');
                if (saveBtn) saveBtn.disabled = false;
                setTimeout(function () { showStatus(''); }, 3000);
                if (fromWelcome && initialPrefsSavedAt === '' && d && d.prefs_saved_at) {
                    var st = d.profile_status;
                    if (st && st.complete) {
                        var accountUrl = (mdMealPrep && mdMealPrep.accountUrl) || '/account/';
                        window.location.href = accountUrl;
                    } else {
                        welcomeRedirect();
                    }
                }
            })
            .catch(function (err) {
                showErr(err.message || String(err));
                if (saveBtn) saveBtn.disabled = false;
            });
    });

    load();
})();
